var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CurrentOrderService } from './currentOrder.service';
import { SharedModule } from './../components/shared.module';
import { FeaturesModule } from './../modules/features/features.module';
import { AlgoliaModule } from './../modules/algolia/algolia.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InputFocusedDirective } from '../directives/input-focused.directive';
import { HelpFooterComponent } from '../components/help-footer.component';
import { orderRouting } from './order.routing';
import { OrderService } from './order.service';
import { OrderComponent } from './order.component';
import { QuoteComponent } from './quote.component';
import { OrderPartComponent } from './wizard/orderpart.component';
import { OrderAddressComponent, OrderAddressGuard } from './wizard/orderaddress.component';
import { OrderBillingComponent, OrderBillingGuard } from './wizard/orderbilling.component';
import { OrderShippingComponent, OrderShippingGuard } from './wizard/ordershipping.component';
import { OrderSummaryComponent, OrderSummaryGuard } from './wizard/ordersummary.component';
import { OrderCompletedComponent, OrderCompletedGuard, QuoteCompletedGuard } from './wizard/ordercompleted.component';
import { OrderValidation } from './orderValidation';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MixpanelService } from './../mixpanel/mixpanel.service';
export function httpFactory(http) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json?t=' + process.env.VERSION);
}
var OrderModule = (function () {
    function OrderModule() {
    }
    OrderModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                SharedModule,
                FormsModule,
                ReactiveFormsModule,
                orderRouting,
                HttpModule,
                FeaturesModule,
                AlgoliaModule.conf(),
                HttpClientModule,
                TranslateModule.forRoot({
                    loader: {
                        provide: TranslateLoader,
                        useFactory: httpFactory,
                        deps: [HttpClient]
                    }
                }),
            ],
            declarations: [
                HelpFooterComponent,
                OrderComponent,
                QuoteComponent,
                OrderPartComponent,
                OrderAddressComponent,
                OrderBillingComponent,
                OrderShippingComponent,
                OrderSummaryComponent,
                OrderCompletedComponent,
                InputFocusedDirective
            ],
            providers: [
                OrderService,
                CurrentOrderService,
                OrderAddressGuard,
                OrderBillingGuard,
                OrderShippingGuard,
                OrderSummaryGuard,
                OrderCompletedGuard,
                QuoteCompletedGuard,
                OrderValidation,
                MixpanelService
            ]
        })
    ], OrderModule);
    return OrderModule;
}());
export { OrderModule };
//# sourceMappingURL=order.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order.module.js
// module id = 582
// module chunks = 0